<template>
  <div class="kw_submit_bar">
    <div class="van-submit-bar custom-class">
      <slot name="top" />

      <div class="van-submit-bar__tip">
        <div v-if="(tip && tip.length > 0)" class="van-submit-bar__tip-text">
          {{ tip }}
        </div>
        <slot name="tip" />
      </div>

      <div class="bar-class">
        <slot />
        <div v-if="(price / 100).toFixed(decimalLength)>0" class="van-submit-bar__text">
          <span class="total_style">{{ label || '合计：' }}</span>
          <span class="van-submit-bar__price price-class">
            <span class="van-submit-bar__currency font_color">{{ currency }} </span>
            <span class="price_style">{{ (price / 100).toFixed(decimalLength) }}</span>
          </span>
          <span class="van-submit-bar__suffix-label">{{ suffixLabel }}</span>
        </div>
        <el-button v-loading="loading" :disabled="disabled" class="van-submit-bar__button" @click="onSubmit" type="danger">{{ loading ? '' : buttonText }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'kw_submit_bar',
  props: {
    buttonItem:Object,
    tip: {
        type: null
    },
    tipIcon: String,
    type: Number,
    price: {
        type: null
    },
    label: String,
    loading: Boolean,
    disabled: Boolean,
    buttonText: String,
    currency: {
        type: String,
        default: '¥'
    },
    buttonType: {
        type: String,
        default: 'danger'
    },
    decimalLength: {
        type: Number,
        default: 2
    },
    suffixLabel: String,
    safeAreaInsetBottom: {
        type: Boolean,
        default: true
    }
  },
  data() {
    return {
      
    };
  },
  created() {
    
  },
  mounted() {
    
  },
  watch:{
  },
  computed:{
  },
  components: {
  },
  methods: {
      onSubmit(event) {
        this.$emit("click",this.buttonItem);
      }
  }
}
        
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .van-submit-bar{position: fixed;bottom: 0;left: 0;width: 100%;-webkit-user-select: none;user-select: none;z-index: 5;background: #fff}
  .van-submit-bar__text{display: inline-block}
  .price_style{font-size: 20px;color: #EE0A24}
  .van-submit-bar__text{margin-right: 15px}
  .van-submit-bar__button{background: #C9081E;border-radius: 0;height: 50px;}

  .bar-class{text-align: right}
  .total_style{color: #323233}
  .font_color{color: #EE0A24}
</style>
